import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import { StyledGiftComponentTitle, StyledGiftIcon, StyledHorizontalChevron } from './styled';

export const IconColumn = (onClick: () => void) => () => (
  <div>
    <StyledGiftIcon color={'icon.highlight'} width="22px" height="22px" onClick={onClick} />
  </div>
);

export const BodyColumn = (isOpen: boolean, onClick: () => void) => () => (
  <StyledGiftComponentTitle onClick={onClick}>
    <FormattedMessage {...messages.giftsTitle} />
    <StyledHorizontalChevron isOpen={isOpen} color={'icon.primary'} size="16px" />
  </StyledGiftComponentTitle>
);

export const InfoColumn = (showGifts: boolean, component: React.ReactNode) => (showGifts ? () => component : null);
